
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import * as React from 'react';
import Head from 'next/head';
import VerifyPassword from 'components/signup/verify-password';
import VerifyCode from 'components/signup/verify-phone-code';
import UserInfo from 'components/signup/user-info';
import LoginFormLayout from 'components/layout/login-form-layout';
enum Steps {
    UserInfo = 'USER_INFO',
    VerifyCode = 'VERIFY_CODE',
    VerifyPassword = 'VERIFY_PASSWORD'
}
export enum IdentifierType {
    Email = 'EMAIL',
    Phone = 'PHONE'
}
// export interface OnCompleteParams {
//     identifier: string
//     identifierType: IdentifierType
//     phone: string
//     name: string
// }
export default function SignupPage() {
    const [identifier, setIdentifier] = React.useState<string>('');
    const [name, setName] = React.useState<string>('');
    const [phone, setPhone] = React.useState<string>();
    const [step, setStep] = React.useState<Steps>(Steps.UserInfo);
    const handleUserInfoComplete = (identifier: string, identifierType: IdentifierType) => {
        setIdentifier(identifier);
        if (identifierType === IdentifierType.Email)
            setStep(Steps.VerifyPassword);
        else
            setStep(Steps.VerifyCode);
    };
    return (<LoginFormLayout>
            <>
                <Head>
                    <title>Registrati</title>
                </Head>

                {step === Steps.UserInfo ? (<UserInfo setName={(val: string) => setName(val)} setPhone={(val: string | undefined) => setPhone(val)} onProceed={handleUserInfoComplete}/>) : step === Steps.VerifyCode ? (<VerifyCode name={name} phone={identifier}/>) : (<VerifyPassword name={name} email={identifier} phone={phone}/>)}
            </>
        </LoginFormLayout>);
}

    async function __Next_Translate__getStaticProps__18d4633978e__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/signup/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__18d4633978e__ as getStaticProps }
  